<!--
 * @Author: 田鑫
 * @Date: 2022-01-10 10:59:38
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-11 10:45:27
 * @Description: 订单详情
-->

<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'reunionPreOrderManagement' }">年夜饭预定订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="detail-container box-shadow">
      <div class="detail-content">
        <div class="row space-between">
          <div class="row-no-padding left">
            <span class="title">预定餐厅：</span>
            <span class="content">{{ orderDetail.canteenName }}</span>
            <el-image class="image" :src="orderDetail.canteenPicture" :preview-src-list="[orderDetail.canteenPicture]"></el-image>
          </div>
          <div class="right" v-show="orderDetail.orderStatus === 1">待完成</div>
          <div class="right" v-show="orderDetail.orderStatus === 2">已完成</div>
          <div class="right" v-show="orderDetail.orderStatus === 3">已取消</div>
        </div>
        <div class="row">
          <span class="title">餐厅电话：</span>
          <span class="content">{{ orderDetail.canteenMobile }}</span>
        </div>
        <div class="row">
          <span class="title">餐厅地址：</span>
          <span class="content">{{ orderDetail.canteenAddress }}</span>
        </div>
        <div class="row">
          <el-table :data="roomList">
            <el-table-column label="房间主图" align="center" prop="roomPicture">
              <template slot-scope="scope">
                <el-image :src="scope.row.roomPicture" :preview-src-list="[scope.row.roowmPicture]" style="max-width: 120px; max-height: 120px; border-radius: 6px"></el-image>
              </template>
            </el-table-column>
            <el-table-column label="房间名称" align="center" prop="roomName"> </el-table-column>
            <el-table-column label="房间容量" align="center" prop="capacity"> </el-table-column>
            <el-table-column label="预定时间" align="center" prop="presetTime">
              <template slot-scope="scope">
                <span style="margin-right: 10px">{{ scope.row.presetTime | formatDate }}</span>
                <span v-if="scope.row.type === 1">上午</span>
                <span v-if="scope.row.type === 2">下午</span>
              </template>
            </el-table-column>
            <el-table-column label="预定电话" align="center" prop="mobile"> </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="detail-footer">
        <div class="row">
          <span class="main-title">订单信息</span>
        </div>
        <div class="row">
          <span class="title">订单号码：</span>
          <span class="content">{{ orderDetail.orderNo }}</span>
        </div>
        <div class="row">
          <span class="title">下单时间：</span>
          <span class="content">{{ orderDetail.createdDate | formatDate(true) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      orderDetail: {},
      roomList: [],
    };
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    const id = this.$route.query.id;
    this.loadDetail(id);
  },
  //生命周期 - 方法
  methods: {
    /**
     * @description: 加载详情
     * @param {*} id
     * @return {*}
     */
    loadDetail(id) {
      this.loading = true;
      this.$http({
        url: global.apiUrl + "/family/order/detail",
        method: "GET",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.loading = false;
            this.orderDetail = res.body.data;
            this.roomList.push({
              roomPicture: this.orderDetail.roomPicture,
              roomName: this.orderDetail.roomName,
              capacity: this.orderDetail.capacity,
              presetTime: this.orderDetail.presetTime,
              mobile: this.orderDetail.mobile,
              type: this.orderDetail.type,
            });
          } else {
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          console.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-container {
  padding: 10px;
  border-radius: 6px;
  .row-no-padding {
    display: flex;
    align-items: center;
  }
  .row {
    padding: 10px;
    display: flex;
    align-items: center;
    .left {
    }
    .right {
      font-size: 20px;
      color: #e9a021;
    }
    .image {
      width: 120px;
      height: 80px;
      border-radius: 6px;
      margin-left: 10px;
    }
    .main-title {
      font-size: 18px;
      font-weight: 600;
      min-width: 100px;
      text-align: right;
    }
    .title {
      font-size: 18px;
      font-weight: 400;
      min-width: 120px;
      text-align: right;
    }
    .content {
      font-size: 16px;
    }
  }
  .detail-content {
    .space-between {
      justify-content: space-between;
    }
  }
  .detail-footer {
    margin-top: 20px;
    border-top: 1px #000 dashed;
  }
}
</style>
